import * as React from 'react'
import { Link } from 'gatsby'

const HeaderButton = (props) =>
{
    const buttonClass = 'inline-flex items-center justify-center hover:contrast-[.25] transition-transform duration-300 transform hover:-translate-y-2 bg-transparent border-white rounded-3xl text-white font-bold py-1 px-3 font-screenCrowFont hover:rounded-2xl mx-4 sm:border-0 lg:border-4';

    return (
        <Link to={props.to} onClick={props.onClick} className={buttonClass}>
            <span className={props.title ? 'text-xl md:text-5xl' : 'text-xl'}>{props.name}</span>
        </Link>
    );
}

export default HeaderButton;
